export const fieldForms = () => {
  return {
    new_field_form: 'New Field Form',
    new_form: 'New Form',
    form_name_placeholder: 'Enter form name',
    description_placeholder: 'Write a short description',
    description: 'Description',
    form_name: 'Form Name',
    field_forms: 'Field Forms',
    next: 'Next',
    work_order_assignment: 'Work Order Assignment',
    assignment_tip: `It’s important to associate a field form to the work orders you
    create and dispatch. The list of trades, services and types are
    pull directly from your WOM system. The application will ensure
    you do not have duplicate field forms per trade, service and
    type.`,
    select_trade: 'Select Trade',
    select_service: 'Select Service',
    select_type: 'Select Type',
    default: 'Default',
    cancel: 'Cancel',
    continue: 'Continue',
    delete: 'Delete',
    clone: 'Clone',
    edit: 'Edit',
    empty_query_message: ' Whoops.. There are no field forms that match your search. Check your search criteria and try again.',
    all_trades: 'All Trades',
    all_services: 'All Services',
    all_types: 'All Types',
    column_names: {
      form_name: 'Form Name',
      status: 'Status',
      last_edit_date: 'Last Edit Date',
      edited_by: 'Edited By',
      trade: 'Trade',
      service: 'Service',
      type: 'Work Order Type',
      actions: 'Actions'
    },
    sort_menu: {
      sort: 'Sort',
      clear: 'Clear',
      highest: 'Highest',
      lowest: 'Lowest',
      oldest: 'Oldest',
      newest: 'Newest'
    },
    remove_modal: {
      title: 'Warning!',
      message: 'You are about to delete {{formName}}, which will no longer be visible.',
      extra_message: 'Would you like to continue?'
    },
    clone_modal: {
      title: 'Clone Field Form',
      message: 'You are about to clone {{formName}}, would you like to continue?',
      extra_message: 'Your form will remain as a draft until edited.'
    }
  }
}
